// capacitor-env.js — the ONE place that answers "are we running inside the
// Capacitor Android/iOS shell (a real device WebView), or an ordinary web
// browser tab?". Both the offline outbox store (outbox.js → getOutbox) and the
// SWR read cache (medplum-live.js) branch on this to pick their on-device
// storage backend (native SQLite/SQLCipher) vs the web backend
// (IndexedDB/localStorage). Kept tiny and dependency-free so the web bundle can
// import it without pulling in any Capacitor plugin code.
//
// Detection is Capacitor's own runtime signal: the shell injects a global
// `Capacitor` object whose `isNativePlatform()` returns true only inside the
// native WebView. On the web there is no such global (or it reports 'web'), so
// this returns false and every consumer keeps its existing web behaviour
// byte-for-byte. There is deliberately NO config flag or env var — the platform
// is a fact of where the code is running, not a setting.

/**
 * True only when running inside the native Capacitor shell (Android/iOS
 * WebView). False in any ordinary web browser / SSR / test (jsdom) context.
 * @returns {boolean}
 */
export function isCapacitorNative() {
  try {
    const cap = (typeof window !== 'undefined' && window.Capacitor) || null;
    return !!(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform());
  } catch (_) {
    return false;
  }
}
